import {
  CloneLodgingRequestActionTypes,
  CloneLodgingRequestState,
  CLONE_LODGING_REQUEST_FAILURE,
  CLONE_LODGING_REQUEST_REQUEST,
  CLONE_LODGING_REQUEST_SUCCESS,
} from 'store/reducers/lodgingRequest/clone/types';

const defaultState: CloneLodgingRequestState = {
  isLoading: false,
  errorMessage: '',
};

export default function cloneLodgingRequest(
  state = defaultState,
  action: CloneLodgingRequestActionTypes
): CloneLodgingRequestState {
  switch (action.type) {
    case CLONE_LODGING_REQUEST_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case CLONE_LODGING_REQUEST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        errorMessage: '',
      };
    case CLONE_LODGING_REQUEST_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: '',
      };
    default:
      return state;
  }
}
